var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCloudDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "cloud-arrow-down-fill",
    d: "M8,2A5.53,5.53,0,0,0,4.406,3.342,4.205,4.205,0,0,0,2.942,5.725,3.675,3.675,0,0,0,3.781,13h8.906a3.223,3.223,0,0,0,.479-6.421A5.136,5.136,0,0,0,8,2Zm2.354,6.854-2,2a.5.5,0,0,1-.708,0l-2-2a.5.5,0,0,1,.708-.708L7.5,9.293V5.5a.5.5,0,0,1,1,0V9.293L9.646,8.146a.5.5,0,1,1,.708.708Z",
    transform: "translate(0 -2)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloudDownload);
export default __webpack_public_path__ + "static/media/ic_cloud_download.3069d7896ec38e9bf9f6719ed5daf6b1.svg";
export { ForwardRef as ReactComponent };